module.exports = __webpack_public_path__ + "img/weather_umberlla.b661bee3.png";